import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Table } from 'primeng/table';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { CreateLicenseBody, ProviderLicencesData, ProviderLicenses } from 'src/app/models/provider';
import {
  order_model,
  Payment_Data,
  PaymentSuccessResult
} from 'src/app/models/basket';
import { TraceClassDecorator } from '@sentry/angular';
import { PaymentComponent } from 'src/app/components/shared/payment/payment.component';
import { ApiResult } from 'src/app/models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import { GraphqlService } from 'src/app/services/graphql.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { ProviderService } from 'src/app/services/provider.service';

enum PAYMENT_FORMS_TABS {
  PACKAGE_FORM = 0,
  PAYMENT_FORMS = 1,
  PAYMENT_SUCCESS = 2
}
@Component({
  selector: 'app-provider-licences',
  templateUrl: './provider-licences.component.html',
  styleUrls: ['./provider-licences.component.css', '../../../../../assets/css/custom-egd.css']
})
export class ProviderLicencesComponent implements OnInit {

  licence_data: ProviderLicencesData = new ProviderLicencesData();
  loading = false;
  licence_id: string = "";
  terms_and_conditions_checkbox: boolean = false;
  error: string = "";
  slug: string = "";
  @ViewChild('dt1') dt1: Table;
  @ViewChild(PaymentComponent) payment_screen: PaymentComponent;
  provider_licence: ProviderLicenses[] = [];

  constructor(private readonly graphqlService: GraphqlService,
    private readonly breadcrumbService: DoctorBreadcrumbService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly providerstateService: ProviderStateService,
    private readonly providerService: ProviderService
  ) {

  }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerstateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
      { label: 'License Plans' }
    ]);
    this.fetchProviderLicences();
  }
  async fetchProviderLicences() {
    this.graphqlService.fetchLicenses().subscribe(
      (result) => {
        if (result && result.data) {
          let temp: ProviderLicenses[] = [];
          for (let i = 0; i < result.data['fetchLicenses'].length; i++) {
            temp.push({
              serial: i + 1,
              id: result.data['fetchLicenses'][i]['id'],
              name: result.data['fetchLicenses'][i]['name'],
              price: result.data['fetchLicenses'][i]['price'],
              expires_after: result.data['fetchLicenses'][i]['expires_after'],
              expiry_type: result.data['fetchLicenses'][i]['expiry_type'],
              number_of_users: result.data['fetchLicenses'][i]['number_of_users'] == null ? "Custom" : result.data['fetchLicenses'][i]['number_of_users'],
              is_active: result.data['fetchLicenses'][i]['is_active'],
              renderedPrice: result.data['fetchLicenses'][i]['renderedPrice'],
              number_of_patients: result.data['fetchLicenses'][i]['number_of_patients'] == null ? "Custom" : result.data['fetchLicenses'][i]['number_of_patients']
            });
          }

          this.provider_licence = temp;
          this.loading = false;
        }
      },
      (error) => {
        console.error('There was an error fetching the count from the API', error);
      }
    );
  }

  async submitPackages() {

    const createLicenseBody: CreateLicenseBody = { license_id: this.licence_data.api_data.selected_license_id, isTrial: true };
    await this.providerService.CreateLicense(createLicenseBody).toPromise().then(async result => {
      this.licence_data.create_api_result.PromiseResult =
        result;
      // this.updatemetadata.create_api_result.PromiseResult.data.response = result;
      if (result.success) {
        window.location.href = result.data.checkoutUrl;
      }
      else {

      }
    }).catch((error: HttpErrorResponse) => {
      this.licence_data.create_api_result.ServerError =
        error.error;
      this.licence_data.create_api_result.PromiseResult.success =
        false;
      this.licence_data.create_api_result.Posting =
        false;
    });

  }


  selectPackage(package_id: string): void {
    if (this.licence_data.api_data.selected_license_id === package_id) {
      // If the package is already selected, deselect it
      this.licence_data.api_data.selected_license_id = "";
    } else {
      // Otherwise, select the package
      this.licence_data.api_data.selected_license_id = package_id;
    }
    this.changeDetector.detectChanges(); // Ensure Angular detects the changes
  }

  isCurrentPackageSelected(package_id: string): boolean {
    return this.licence_data.api_data.selected_license_id == package_id;
  }
}
